import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150" fill="none">
    {props.children}
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M145.9 102.2 75.2 61.5l-71 40.9L74.9 143l71-40.9Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.98 6.98"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M145.7 108.7 75 68.1 4.1 109l70.6 40.6 71-40.9Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M46.2.4 101.3 32l.2 2.4L46.2 66V.4Zm0 72.4 55.1-31.6.2 81.1-55.3-32V72.7Z"
    />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m79.1 122.3-20-11.6L59 90l20 11.6v20.7Z"
    />
    <path
      fill="#eea2a2"
      d="M72.5 57.7v12l-1.1-.6V58.3l1.1-.6ZM72 81.5c-.4-.2-.7-.5-1-.9l-.3-1.2c0-.4.1-.6.4-.8h.9l.9.9.3 1.1-.1.7-.5.3a1 1 0 0 1-.6-.2Zm.5-30.5v-9.3l-1.1-.6v10.6l1.1-.7Z"
    />
    <path
      fill="#eea2a2"
      d="M71 80.6c.3.4.6.7 1 .9h.6c.2 0 .3 0 .4-.2.2-.2.2-.4.2-.6 0-.4-.1-.8-.4-1.2a2 2 0 0 0-.9-.8c-.3-.2-.6-.2-.8 0-.3 0-.4.4-.4.8s.1.7.4 1.1Z"
    />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M46.2.4 101.3 32l.2 2.4L46.2 66V.4Zm0 72.4 55.1-31.6.2 81.1-55.3-32V72.7Z"
    />
    <path
      fill="#eea2a2"
      fillRule="evenodd"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m92.8 19 4.6-1.6c3.9-1.3 8.8-.2 13.6 3.8a42 42 0 0 1 13.6 36c-1.1 5.9-4 9.7-8 11.1l-4.4 1.6c3.9-1.4 6.7-5.2 7.8-11.2 2-11.9-4-27.9-13.6-36-4.8-4-9.7-5-13.6-3.7Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.5}
      d="M106.8 22.6c-4.9-4-9.6-5-13.4-3.7-3.9 1.3-6.8 5-7.8 11s0 13 2.4 19.6A39.5 39.5 0 0 0 99.2 66c4.8 4 9.6 5.1 13.4 3.8 3.8-1.3 6.7-5 7.7-11 1-6.1.1-13.2-2.3-19.7a39.6 39.6 0 0 0-11.3-16.5Z"
    />
    <path
      fill="#eea2a2"
      stroke="#eea2a2"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m110.4 60.7-1.4.7 4-3.6.2.3-2.8 2.6ZM98.5 53l-2.8 1.3 15.9-14 2.1-1.1-15.2 13.7Z"
    />
    <path
      fill="#eea2a2"
      stroke="#eea2a2"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m111.5 34.7-2.2 1 2.2 4.6 2.2-1.1-2.2-4.5Zm-12.7-6.8-2.5 1 6.1 12.5 2.1-1.7L98.8 28ZM107 45l-2.2 1.6 6.3 12.7 2.1-1.4L107 45Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m96.3 28.8 6.2 12.8 6.7-6 2.3 4.7-7 6.2 6.3 12.8-3 2.7-6.3-12.8-5.8 5-2.1-4.7 5.9-5.2-6.3-12.8 3-2.6Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M53.6 53.4 30.5 40V18.8l23 13.5v21Z"
    />
    <path
      fill="#eea2a2"
      stroke="#15161a"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m53.6 53.4 2-1.3v-21l-2 1.2v21Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m53.6 32.3 2-1.3-23.2-13.5-2 1.3 23.2 13.5Z"
    />
    <path fill="#eea2a2" stroke="#000" strokeWidth={0.5} d="m31.7 102 6 3.4-6.6 3.8-6-3.4 6.6-3.8Z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="m39.7 106.6 12.9 7.4-6.6 3.8-12.9-7.4 6.6-3.8ZM52.8 118l16.5 9.9"
    />
  </svg>
);
